/**
 * ArticleRow composite component exports
 *
 * Exports the ArticleRow component, its props interface, variant functions,
 * and variant props types for use throughout the application.
 */
export { ArticleRow, GRID_GAPS, type ArticleRowProps } from './ArticleRow';
export {
  articleRowContainerVariants,
  articleRowGridVariants,
  heroOverlayVariants,
  type ArticleRowContainerVariantProps,
  type ArticleRowGridVariantProps,
  type HeroOverlayVariantProps,
} from './article-row.variants';
